'use client'

import { atomFamily } from 'jotai-family'
import { selectAtom } from 'jotai/utils'

import { instanceListView, sameListView } from '@/features/options-mm/lib/instance-list'
import { algoStatesRawAtom } from '@/state/account'
import { venueTelemetryAtom } from '@/state/venue-telemetry'

// Narrow views for the Options MM page, so a component re-renders only on the
// frames it draws (mergeAlgoStates keeps untouched entries' identity, and
// applyVenueTelemetry keeps other accounts').

/** One instance's AlgoState; changes only on that instance's own frames. */
export const optionsMmInstanceAtomFamily = atomFamily((algoId: string) =>
  selectAtom(algoStatesRawAtom, (states) => states.find((s) => s.id === algoId))
)

/** The instances list, grouped by account; equal frames keep the previous value. */
export const optionsMmInstanceListAtomFamily = atomFamily((includeEnded: boolean) =>
  selectAtom(algoStatesRawAtom, (states) => instanceListView(states, includeEnded), sameListView)
)

/** One account's MM venue telemetry. */
export const venueTelemetryForAccountAtomFamily = atomFamily((accountId: string) =>
  selectAtom(venueTelemetryAtom, (byAccount) => byAccount[accountId])
)

/** Drops the per-instance and per-account entries, which otherwise live for the session. */
export function forgetOptionsMmAtoms() {
  for (const id of [...optionsMmInstanceAtomFamily.getParams()]) {
    optionsMmInstanceAtomFamily.remove(id)
  }
  for (const id of [...venueTelemetryForAccountAtomFamily.getParams()]) {
    venueTelemetryForAccountAtomFamily.remove(id)
  }
}
